import { mapGetters, mapActions } from "vuex";

export const dragAndZoom = {
  data() {
    return {
      zoomState: 1.0,
      maxScale: 4.0,
    };
  },
  computed: {
    ...mapGetters(["getZoomState", "activeMapButton", "streetViewStatus"]),
  },
  methods: {
    ...mapActions(["setZoomState"]),
    /**
     * @description zoom map area
     * @param { <bool> } reset reset to zoom level 1
     * @param {<number> } increment zoom in or out by increment
     */
    zoom: function (reset, increment) {
      let newZoomState = this.zoomState;
      if (this.streetViewStatus === this.$t('hellovue.view.cross_section_view')) {
        if (!reset) {
          newZoomState = increment + this.zoomState;
        } else {
          newZoomState = 1;
        }
        this.zoomState = newZoomState;
        this.zoomState = Math.max(1, Math.min(this.maxScale, this.zoomState));

        document.querySelector("#component-image-holder").style.transformOrigin = ``;
        document.querySelector("#component-image-holder").style.transform = `scale(${this.zoomState})`;
      }
    },
    // zoon to pin
    zoomToPin: function (event) {
      const figure = document.querySelector("#component-image-holder");
      if (this.activeButton) {
        figure.style.transform = "scale(1)";
        const imageHolderLeft = event.currentTarget.dataset.xcoord;
        const imageHolderTop = event.currentTarget.dataset.ycoord;
        figure.style.transformOrigin = `${imageHolderLeft}% ${imageHolderTop}%`;
        figure.style.transform = "scale(2)";
      } else {
        figure.style.transform = "scale(1)";
      }
    },
  },
};
